// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as DndKit$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/DndKit.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var DndApiSig = {
  name: "RefManagerApi"
};

var DndApi = ContextMaker$LiteracyplanetClientFlags.Make(DndApiSig);

var DndSig = {};

var Dnd = DndKit$LiteracyplanetClientFlags.Make(DndSig);

var groupSplitChar = ":";

function makeUniqueIdFromIndex(index, id) {
  return index + groupSplitChar + id;
}

function makeCloneId(id) {
  return "dragOverlayClone-" + id;
}

var cloneIdContainer = "dragOverlayClones";

function V3DndBehaviour$DragOverlay$RenderOverlay(props) {
  var id = props.id;
  var overlayDiv = React.useRef(null);
  var match = V3RefManager$LiteracyplanetTupperware.use();
  var lookupRef = match.lookupRef;
  React.useEffect((function () {
          var match = lookupRef(makeCloneId(id));
          var match$1 = overlayDiv.current;
          if (match !== undefined && !(match$1 == null)) {
            var cloned = Caml_option.valFromOption(match).cloneNode(true);
            match$1.appendChild(cloned);
          }
          
        }), [id]);
  return React.createElement("div", {
              ref: Caml_option.some(overlayDiv)
            });
}

var RenderOverlay = {
  make: V3DndBehaviour$DragOverlay$RenderOverlay
};

function V3DndBehaviour$DragOverlay(props) {
  var makeOverlayElement = function (t) {
    if (t.TAG === "Drop") {
      return ;
    } else {
      return Caml_option.some(React.createElement(V3DndBehaviour$DragOverlay$RenderOverlay, {
                      id: t.dragId
                    }));
    }
  };
  var context = Dnd.useDndContext();
  return React.createElement(React.Fragment, {}, React.createElement("div", {
                  style: {
                    display: "none"
                  }
                }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                      id: cloneIdContainer,
                      children: null
                    })), React.createElement(Dnd.DragOverlay.make, {
                  children: Belt_Option.getWithDefault(Belt_Option.flatMap(context.active, makeOverlayElement), "Drag Overlay Broken")
                }));
}

var DragOverlay = {
  makeCloneId: makeCloneId,
  cloneIdContainer: cloneIdContainer,
  RenderOverlay: RenderOverlay,
  make: V3DndBehaviour$DragOverlay
};

function V3DndBehaviour$DragOverlayComponentRef(props) {
  var match = DndApi.use();
  return React.createElement(V3RefManager$LiteracyplanetTupperware.Portal.make, {
              id: cloneIdContainer,
              children: React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                    id: makeCloneId(props.id),
                    children: match.renderDragOverlayComponent(props.children)
                  })
            });
}

var DragOverlayComponentRef = {
  make: V3DndBehaviour$DragOverlayComponentRef
};

function V3DndBehaviour$PortalToDropComponent(props) {
  var droppedId = props.droppedId;
  var dragId = props.dragId;
  var match = DndApi.use();
  var onUndoDrop = match.onUndoDrop;
  return React.createElement(V3RefManager$LiteracyplanetTupperware.Portal.make, {
              id: droppedId,
              children: match.renderDroppedComponent((function (param) {
                      onUndoDrop(dragId, droppedId);
                    }), props.children)
            });
}

var PortalToDropComponent = {
  make: V3DndBehaviour$PortalToDropComponent
};

function V3DndBehaviour$PortalToCorrectDropComponent(props) {
  var match = DndApi.use();
  return React.createElement(V3RefManager$LiteracyplanetTupperware.Portal.make, {
              id: props.droppedId,
              children: match.renderCorrectDroppedComponent(undefined, props.children)
            });
}

var PortalToCorrectDropComponent = {
  make: V3DndBehaviour$PortalToCorrectDropComponent
};

function V3DndBehaviour$PortalToIncorrectDropComponent(props) {
  var match = DndApi.use();
  return React.createElement(V3RefManager$LiteracyplanetTupperware.Portal.make, {
              id: props.droppedId,
              children: match.renderIncorrectDroppedComponent(undefined, props.children)
            });
}

var PortalToIncorrectDropComponent = {
  make: V3DndBehaviour$PortalToIncorrectDropComponent
};

function V3DndBehaviour$Drag(props) {
  var children = props.children;
  var id = props.id;
  var match = DndApi.use();
  var renderUndroppedMarkedComponent = match.renderUndroppedMarkedComponent;
  var renderAlreadyDraggedAndMarkedPlaceholder = match.renderAlreadyDraggedAndMarkedPlaceholder;
  var onUndoDrop = match.onUndoDrop;
  var answerVisible = match.answerVisible;
  var tmp;
  var exit = 0;
  if (answerVisible !== undefined && answerVisible) {
    tmp = Belt_Option.mapWithDefault(match.findCorrectResponse(id, props.index), null, (function (droppedId) {
            return React.createElement(React.Fragment, {}, renderAlreadyDraggedAndMarkedPlaceholder(undefined, children), React.createElement(V3DndBehaviour$PortalToCorrectDropComponent, {
                            droppedId: droppedId,
                            children: children
                          }));
          }));
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var match$1 = match.findDroppedId(id);
    var match$2 = match.getMarkType(id);
    if (match$1 !== undefined) {
      switch (match$2) {
        case "Correct" :
            tmp = React.createElement(React.Fragment, {}, renderAlreadyDraggedAndMarkedPlaceholder(undefined, children), React.createElement(V3DndBehaviour$PortalToCorrectDropComponent, {
                      droppedId: match$1,
                      children: children
                    }));
            break;
        case "Wrong" :
            tmp = React.createElement(React.Fragment, {}, renderAlreadyDraggedAndMarkedPlaceholder(undefined, children), React.createElement(V3DndBehaviour$PortalToIncorrectDropComponent, {
                      droppedId: match$1,
                      children: children
                    }));
            break;
        case "Unanswered" :
            tmp = React.createElement(React.Fragment, {}, match.renderAlreadyDraggedPlaceholder((function (param) {
                        onUndoDrop(id, match$1);
                      }), children), React.createElement(V3DndBehaviour$PortalToDropComponent, {
                      dragId: id,
                      droppedId: match$1,
                      children: children
                    }));
            break;
        
      }
    } else {
      switch (match$2) {
        case "Correct" :
        case "Wrong" :
            tmp = renderUndroppedMarkedComponent(undefined, children);
            break;
        case "Unanswered" :
            tmp = match.renderDragComponent(undefined, JsxPPXReactSupportU.createElementWithKey(id, Dnd.DraggableItem.make, {
                      id: id,
                      className: props.dragClassName,
                      t: {
                        TAG: "Drag",
                        dragId: id
                      },
                      dom: "button",
                      handle: true,
                      hideOnDrag: true,
                      children: children
                    }));
            break;
        
      }
    }
  }
  return React.createElement(React.Fragment, {}, tmp, React.createElement(V3DndBehaviour$DragOverlayComponentRef, {
                  id: id,
                  children: children
                }));
}

var Drag = {
  make: V3DndBehaviour$Drag
};

function V3DndBehaviour$DropChainItem(props) {
  var __dom = props.dom;
  var uniqueId = props.uniqueId;
  var id = props.id;
  var dom = __dom !== undefined ? __dom : "div";
  var match = React.useState(function () {
        return false;
      });
  var setOver = match[1];
  var match$1 = DndApi.use();
  var dropped = match$1.isDropped(uniqueId);
  var onDragOver = function (param) {
    var over = param.over;
    if (over !== undefined && over.TAG === "Drop") {
      var group = over.group;
      if (group !== undefined && over.dropId === id && group === uniqueId) {
        return setOver(function (param) {
                    return true;
                  });
      }
      
    }
    setOver(function (param) {
          return false;
        });
  };
  var onDragEnd = function (param) {
    setOver(function (param) {
          return false;
        });
  };
  Dnd.useDndMonitor(undefined, onDragOver, onDragEnd, undefined, undefined);
  return JsxPPXReactSupportU.createElementWithKey(uniqueId, Dnd.Droppable.make, {
              id: uniqueId,
              className: props.containerClassname,
              t: {
                TAG: "Drop",
                dropId: id,
                group: uniqueId
              },
              dom: dom,
              children: React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                    id: uniqueId,
                    className: match[0] ? match$1.overClassName : match$1.dropClassName,
                    children: dropped || match$1.answerVisible === true ? null : React.createElement("span", undefined, "__")
                  })
            });
}

var DropChainItem = {
  make: V3DndBehaviour$DropChainItem
};

function V3DndBehaviour$Drop(props) {
  var __dom = props.dom;
  var id = props.id;
  var dom = __dom !== undefined ? __dom : "div";
  var match = React.useState(function () {
        return false;
      });
  var setOver = match[1];
  var match$1 = DndApi.use();
  var onDragOver = function (param) {
    var over = param.over;
    if (over !== undefined && over.TAG === "Drop" && over.dropId === id) {
      return setOver(function (param) {
                  return true;
                });
    }
    setOver(function (param) {
          return false;
        });
  };
  var onDragEnd = function (param) {
    setOver(function (param) {
          return false;
        });
  };
  Dnd.useDndMonitor(undefined, onDragOver, onDragEnd, undefined, undefined);
  return JsxPPXReactSupportU.createElementWithKey(id, Dnd.Droppable.make, {
              id: id,
              className: props.containerClassname,
              t: {
                TAG: "Drop",
                dropId: id
              },
              dom: dom,
              children: React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                    id: id,
                    className: match[0] ? match$1.overClassName : match$1.dropClassName,
                    children: React.createElement("div", {
                          className: props.headerClassname
                        }, props.children)
                  })
            });
}

var Drop = {
  make: V3DndBehaviour$Drop
};

function V3DndBehaviour$DropNoChildren(props) {
  var __elementRef = props.elementRef;
  var __dom = props.dom;
  var id = props.id;
  var dom = __dom !== undefined ? __dom : "div";
  var elementRef = __elementRef !== undefined ? __elementRef : "div";
  V3RefManager$LiteracyplanetTupperware.use();
  var match = React.useState(function () {
        return false;
      });
  var setOver = match[1];
  var over = match[0];
  var match$1 = DndApi.use();
  var dropped = match$1.isDropped(id);
  var onDragOver = function (param) {
    var over = param.over;
    if (over !== undefined && over.TAG === "Drop" && over.dropId === id) {
      return setOver(function (param) {
                  return true;
                });
    }
    setOver(function (param) {
          return false;
        });
  };
  var onDragEnd = function (param) {
    setOver(function (param) {
          return false;
        });
  };
  Dnd.useDndMonitor(undefined, onDragOver, onDragEnd, undefined, undefined);
  return JsxPPXReactSupportU.createElementWithKey(id, Dnd.Droppable.make, {
              id: id,
              className: over ? props.containerOverClassname : props.containerClassname,
              t: {
                TAG: "Drop",
                dropId: id
              },
              dom: dom,
              children: React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                    element: elementRef,
                    id: id,
                    className: over ? match$1.overClassName : match$1.dropClassName,
                    children: dropped || match$1.answerVisible === true ? null : React.createElement("span", undefined, "__")
                  })
            });
}

var DropNoChildren = {
  make: V3DndBehaviour$DropNoChildren
};

function V3DndBehaviour$DndMonitor(props) {
  var match = DndApi.use();
  var onDrop = match.onDrop;
  var onDragEnd = function (param) {
    var over = param.over;
    var active = param.active;
    if (active.TAG === "Drop") {
      return ;
    }
    if (over === undefined) {
      return ;
    }
    var dragId = active.dragId;
    if (over.TAG !== "Drop") {
      return ;
    }
    var group = over.group;
    var dropId = over.dropId;
    if (group !== undefined) {
      return onDrop(dragId, dropId, group);
    } else {
      return onDrop(dragId, dropId, undefined);
    }
  };
  Dnd.useDndMonitor(undefined, undefined, onDragEnd, undefined, undefined);
  return props.children;
}

var DndMonitor = {
  make: V3DndBehaviour$DndMonitor
};

function V3DndBehaviour$DndProvider(props) {
  return React.createElement(DndApi.Provider.make, {
              value: props.api,
              children: React.createElement(Dnd.Provider.make, {
                    children: React.createElement(V3DndBehaviour$DndMonitor, {
                          children: null
                        }, props.children, React.createElement(V3DndBehaviour$DragOverlay, {}))
                  })
            });
}

var DndProvider = {
  make: V3DndBehaviour$DndProvider
};

export {
  DndApiSig ,
  DndApi ,
  DndSig ,
  Dnd ,
  groupSplitChar ,
  makeUniqueIdFromIndex ,
  DragOverlay ,
  DragOverlayComponentRef ,
  PortalToDropComponent ,
  PortalToCorrectDropComponent ,
  PortalToIncorrectDropComponent ,
  Drag ,
  DropChainItem ,
  Drop ,
  DropNoChildren ,
  DndMonitor ,
  DndProvider ,
}
/* DndApi Not a pure module */
